const seniorityMap: { [key: string]: number } = {
  Trainee: 0,
  Junior: 1,
  Medium: 2,
  'Mid-level': 2,
  Senior: 3,
  Expert: 4,
  Principal: 5,
};

export function sortSeniority(
  leftSeniority: string,
  rightSeniority: string,
): number {
  const left = seniorityMap[leftSeniority] ?? 6;
  const right = seniorityMap[rightSeniority] ?? 6;
  return left - right;
}
